export default __webpack_public_path__ + "dcb962cb4dc1deeed264954d234f9e2b.png";